/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useState, useContext } from "react";
import Header from "./components/Header";
import Button from "../../components/Button";
import LoginPage from "./components/LoginPage";
import Totp from "./components/Totp";
import { useDispatch , useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Amplify, Auth } from "aws-amplify";
import { updateUserDetails, verifyOtp } from "./authSlice";
import { validateEmail } from "../../CommonMethods/EmailValidator";
import GlobalContext from "../../components/Context/GlobalContext";
import moment from 'moment'
import { addPrivileges } from "./privilagesSlice";
import { dataService } from "../../services/data.services";
// import { routeChecker } from "../../CommonsMethods/checkPrivilege";

function Login() {
    const [submitSelected, setsubmitSelected] = useState(false);
    const location = useNavigate();
    const dispactch = useDispatch();
    const [IsLoginPage, setIsLoginPage] = useState(true);
    const [loading, setloading] = useState(false);
    const [userData, setuserData] = useState({});
    const navigate = useNavigate();
    const privileges = useSelector(state => state?.Privilages?.privileges)

    const [loginCredentials, setloginCredentials] = useState({
        email: "",
        password: "",
    });
    const { setToastmessage, setToastErrorMessage, Toastmessage,setToastError } = useContext(GlobalContext)
    const [Qrcode, setQrcode] = useState("");
    const [error, seterror] = useState(false);
    const [errorState, seterrorState] = useState({ email: "", password: "" });
    const [otp, setOtp] = useState(Array(6).fill(""));
    const [timer, setTimer] = useState(30);
    const [loginError, setloginError] = useState("");
    const { email, password } = loginCredentials;
    const [otpError, setotpError] = useState("");
    const handleInput = (key, value) => {
        setloginCredentials((prv) => ({
            ...prv,
            [key]: value,
        }));
    };
    async function updateUserAttributes(url) {
        try {
            const user = await Auth.currentAuthenticatedUser();
            const result = await Auth.updateUserAttributes(user, {
                "custom:mfa_secret": url,
            });
        } catch (err) {
            console.log(err);
        }
    }
    const initialPaths = {
        "view_dashboard": "/dashboard",
        "admin_user_list": "/manage-admin-users",
        "merchant_list": "/manage-merchants",
        "order_list": "/orders-purchases",
        "support_request_list": "/supports",
        "settlement_list": "/settlements",
        "password_update": "/password-update"
    };
    const routeCheker = (privilege, obj) => {
        for (let key in obj) {
            if (obj[key] && privilege.hasOwnProperty(key)) {
                return obj[key];
            }
        }
        return null; // If no matching key is found
    }
    const handleLogin = async (e, key) => {
        e.preventDefault();
        setsubmitSelected(true);
        setloginError("");
        seterror(false);
        setloading(true);
        if (
            email === "" ||
            password === "" ||
            (email !== "" && password === "") ||
            (email === "" && password !== "")
        ) {
            setloginError("This field is mandatory");
            setloading(false);

            return;
        }
        if (validateEmail(email)) {
            setloading(false);
            setloginError("Invalid email address or password");
            return;
        }
        try {
            const loginAccess = await dataService.GetAPINoHeader(`admin-users/login-verifier?email_address=${encodeURIComponent(email)}&application=admin`)
            if (loginAccess?.data?.status !== 200 || !loginAccess?.data?.data?.data?.valid) {
                setloading(false);
                setloginError("Invalid email address or password");
                return
            }
        } catch (error) {
            setloading(false);
            console.log(error)
        }
        try {
            const loginresponse = await Auth.signIn(email, password);
            if (loginresponse.challengeName === undefined) {
                const res = await Auth.setupTOTP(loginresponse);
                const authCode =
                    `otpauth://totp/${email}` +
                    loginresponse.username +
                    "?secret=" +
                    res +
                    "&issuer=Maison QR - Admin ";
                await updateUserAttributes(authCode);
                if (authCode) {
                    // set qr ui
                    setQrcode(authCode);
                    setloading(false);
                }
            }
            setuserData(loginresponse);
            setloading(false);
            setsubmitSelected(false);

            setIsLoginPage(false);
            if (key) {
                setTimer(30);
            }
            // Login successful, redirect or perform any other actions
        } catch (error) {
            if (error.code === "UserNotConfirmedException") {
                // User is not confirmed
                // Show a message or redirect to a confirmation page
                setloginError("UserNotConfirmelocalStorage.setItem('login_time', moment());dException");
            } else if (
                error.code === "NotAuthorizedException" &&
                error.message !== "User is disabled."
            ) {
                // Incorrect username or password
                // Show an error message
                setloginError("Invalid email address or password");
            } else if (
                error.code === "NotAuthorizedException" &&
                error.message === "User is disabled."
            ) {
                setloginError("Deactivated account. Please contact support");
            } else if (error.code === "UserNotFoundException") {
                // User does not exist
                // Show an error message or redirect to a signup page
                setloginError("Invalid email address or password");
            } else if (error.code === "InvalidLambdaResponseException") {
                setloginError(
                    "User account is disabled. Please contact our support team for assistance."
                );
            } else if (error.code === "UserLambdaValidationException") {
                // Handle other exceptions or display a generic error message
                setloginError("Incorrect email address or password");
            } else if (error.code === "InvalidParameterException") {
                // Handle other exceptions or display a generic error message
                setloginError("Incorrect email address or password");
            } else {
                setloginError("Something went wrong");
            }
            seterror(true);
            setloading(false);
        }
    };

    function processPermissions(permissionsString, previousPrivileges = {}) {
        // Handle empty or invalid input gracefully
        if (!permissionsString || typeof permissionsString !== 'string') {
            return previousPrivileges; // Return previous state if input is invalid
        }
    
        // Validate format (optional):
        // You can add optional checborderks to ensure the input string is in the expected format
        // using regular expressions or other validation techniques.
    
        // Split and convert to object:
        const processedPermissions = permissionsString.split(',')
            .map(permission => permission.trim()) // Remove leading/trailing whitespace
            .reduce((acc, permission) => ({ ...acc, [permission]: true }), {});
    
        // Merge processed permissions with previous state
        return { ...previousPrivileges, ...processedPermissions };
    }
    const handleTotpVerify = async (e) => {
        e.preventDefault();
        setsubmitSelected(true);
        setotpError("");
        const val = otp.toString().replace(/,/g, "");
        if (val.split("").length < 6) {
            setotpError("Invalid OTP");
            setloading(false);
            return;
        }
        setloading(true);
        let cognitoUserSession = "";
        try {
            if (userData.Session && userData.Session !== null) {
                cognitoUserSession = await Auth.confirmSignIn(
                    userData,
                    val,
                    "SOFTWARE_TOKEN_MFA"
                );
            } else {
                const cognitoUserSession = await Auth.verifyTotpToken(userData, val);
                await Auth.setPreferredMFA(userData, "TOTP");
            }
            // don't forget to set TOTP as the preferred MFA method
            setloading(false);
            dispactch(verifyOtp(email));
            dispactch(addPrivileges(userData.attributes?.['custom:admin_privileges']))
            let res = processPermissions(userData.attributes?.['custom:admin_privileges'])
            dispactch(updateUserDetails(userData.attributes?.['name']))
            setToastmessage("Login successful");
            
            const path = routeCheker(res,initialPaths)
            navigate(path)
            localStorage.setItem('login_time', moment());
        } catch (error) {
            if (error.message.includes("session is expired")) {
                setToastError('Session expired.Please login again')
                setIsLoginPage(true);
                // setotpError("OTP has expired");
            } else if (error.message.includes("mismatch")) {
                setotpError("Invalid OTP");
            } else if (error.message === "Missing required parameter Session") {
                setotpError("Missing required parameter Session");
            } else if (error.code === "CodeMismatchException") {
                setotpError("Invalid OTP");
            } else {
                // handleToast(error.message, 'error');
            }
            setloading(false);
        }
    };
    return (
        <div className="h-full bg-[#F5F5F5]">
            {IsLoginPage ? (
                <LoginPage
                    submitSelected={submitSelected}
                    handleLogin={handleLogin}
                    setsubmitSelected={setsubmitSelected}
                    handleInput={handleInput}
                    loading={loading}
                    loginError={loginError}
                    errorState={errorState}
                    loginFields={loginCredentials}
                />
            ) : (
                <Totp
                    Qrcode={Qrcode}
                    userData={userData}
                    loading={loading}
                    otp={otp}
                    setOtp={setOtp}
                    submitSelected={submitSelected}
                    handleSubmit={handleTotpVerify}
                    otpError={otpError}
                    setotpError={setotpError}
                    setsubmitSelected={setsubmitSelected}
                    setIsLoginPage={setIsLoginPage}
                />
            )}
        </div>
    );
}

export default Login;
